import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.get('/auth/me').then(setUser).catch(() => localStorage.removeItem('token')).finally(() => setLoading(false));
    } else { setLoading(false); }
  }, []);

  // `antesDeEntrar` (opcional) corre con la sesión ya validada y antes de cambiar
  // de pantalla: el Login lo usa para apagar sus tubos antes de desmontarse.
  const login = async (email, password, antesDeEntrar) => {
    const { token, user } = await api.post('/auth/login', { email, password });
    localStorage.setItem('token', token);
    if (antesDeEntrar) await antesDeEntrar();
    // /auth/me trae además los permisos calculados (p. ej. si aprueba requisiciones)
    const completo = await api.get('/auth/me').catch(() => user);
    setUser(completo);
    return completo;
  };

  const logout = () => { localStorage.removeItem('token'); setUser(null); };

  const refreshUser = () => api.get('/auth/me').then(setUser);

  return <AuthCtx.Provider value={{ user, login, logout, loading, refreshUser }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
